import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { db, storage } from "../../lib/firebase";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";

const label = { display:"block", margin:"14px 0 6px", opacity:.9 };
const input = { width:"100%", padding:12, borderRadius:12, border:"1px solid rgba(255,209,59,.3)", background:"rgba(0,0,0,.35)", color:"#e9eef5" };
const btn   = { marginTop:16, background:"#ffd13b", color:"#0b0f14", padding:"12px 18px", borderRadius:999, fontWeight:800, border:"none", cursor:"pointer" };

export default function EditPost() {
  const { slug } = useParams();
  const nav = useNavigate();
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");
  const [title, setTitle] = useState("");
  const [excerpt, setExcerpt] = useState("");
  const [content, setContent] = useState("");
  const [coverUrl, setCoverUrl] = useState("");
  const [file, setFile] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        setErr("");
        const snap = await getDoc(doc(db, "posts", slug));
        if (!snap.exists()) {
          setErr("Post not found");
        } else {
          const p = snap.data();
          setTitle(p.title || "");
          setExcerpt(p.excerpt || "");
          setContent(p.content || "");
          setCoverUrl(p.coverUrl || "");
        }
      } catch (e) {
        console.warn(e);
        setErr(e.message || "Failed to load post");
      } finally {
        setLoading(false);
      }
    })();
  }, [slug]);

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setErr("");
    try {
      let newCover = coverUrl;
      if (file) {
        const r = ref(storage, `covers/${slug}-${Date.now()}`);
        await uploadBytes(r, file);
        newCover = await getDownloadURL(r);
      }
      await updateDoc(doc(db, "posts", slug), { title, excerpt, content, coverUrl: newCover });
      nav(`/blog/${slug}`);
    } catch (e) {
      console.warn(e);
      setErr(e.message || "Save failed");
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div style={{ color:"#e9eef5", margin:"90px auto", maxWidth:900, padding:"0 18px" }}>Loading…</div>;

  return (
    <form onSubmit={submit} style={{ maxWidth: 900, margin:"90px auto", padding:"0 18px", color:"#e9eef5" }}>
      <h1 style={{ color:"#ffd13b" }}>Edit Post</h1>
      {err && <div style={{ color:"salmon", marginBottom:12, fontWeight:700 }}>ERROR: {err}</div>}

      <div style={{ opacity:.8, marginBottom:10 }}>Slug: {slug}</div>

      <label style={label}>Title</label>
      <input style={input} value={title} onChange={e=>setTitle(e.target.value)} />

      <label style={label}>Excerpt</label>
      <textarea style={input} rows={3} value={excerpt} onChange={e=>setExcerpt(e.target.value)} />

      <label style={label}>Current Cover</label>
      {coverUrl ? (
        <img src={coverUrl} alt="" style={{ width:"100%", borderRadius:12, margin:"8px 0 12px" }} />
      ) : <div style={{ opacity:.7, marginBottom:12 }}>No cover uploaded</div>}

      <label style={label}>Replace Cover (optional)</label>
      <input type="file" accept="image/*" onChange={e=>setFile(e.target.files?.[0]||null)} style={{ color:"#e9eef5" }}/>

      <label style={label}>Content (Markdown)</label>
      <textarea style={input} rows={12} value={content} onChange={e=>setContent(e.target.value)} />

      <button disabled={saving} style={btn}>{saving ? "Saving..." : "Save Changes"}</button>
    </form>
  );
}
